/**
 * Created by guga on 8/19/2016.
 */

import { Injectable } from "@angular/core";

import { isValidValue }                        from './valid-value-check';
import { IXhrResponse, IXhrOptions, IXhrHeaders } from '../sas-models/xhr-types';

import { Observable }   from "rxjs/Observable";
import { Observer }     from "rxjs/Observer";
import "rxjs/add/operator/map";
import "rxjs/add/operator/catch";

/***********************************************
 * Author : Gustavo(gmm)
 * Date   : 19/08/2016
 *
 * This service is an extremely low level SAS. Only use if you know what you are doing.
 *
 * Sometimes, HttpModule do not satisfies us, and we need to get to low level. This SAS provide methods to use XMLHttpRequest directly
 * without losing SAS design pattern. It is also used by AuthXhrSas and AuthXhrWrapperSas if you want to make authenticated requests.
 *
 *  !!!!
 *    This service only emits 1 data (XhrResponse) on success and then complete, and 1 data (XhrResponse) on error.
 *
 * Use "request" method for generic use.
 *
 * Example of use :
 *
 *   ## GET
 *   this._xhrSas.get('http://docpad.com.br/api/something', { "Authorization" : "Bearer blablabla" }, { "responseType" : "blob" }).subscribe(
 *      (xhrResponse : XhrResponse) => console.log(xhrResponse.body),
 *      (xhrResponse : XhrResponse) => console.log("Error code : " + xhrResponse.status)
 *   );
 *
 ***********************************************/

@Injectable()
export class XhrSas {
    private _createXhr(method : string, path : string, async ?: boolean) : XMLHttpRequest {
        let isAsync : boolean = (isValidValue(async))? async : true;
        let xhr               = new XMLHttpRequest();
        xhr.open(method, path, isAsync);
        return xhr;
    }
    private _mergeOptions(originalXhr : XMLHttpRequest, options : {[key : string] : any}) : void {
        if (!options || !originalXhr)
            return;

        for (let key in options)
            (<any>originalXhr)[key] = options[key];
    }
    private _mergeHeaders(originalXhr : XMLHttpRequest, headers : {[key : string] : string}) : void {
        if (!originalXhr || !headers)
            return;

        for (let key in headers)
            originalXhr.setRequestHeader(key, headers[key]);
    }
    private _doRequest(xhr : XMLHttpRequest, data : any) : Observable<IXhrResponse> {
        return new Observable<IXhrResponse>(
            (observer : Observer<IXhrResponse>) => {
                let loadHandler = (ev : Event) => {
                    let xhrResponse : IXhrResponse = {
                        body       : xhr.response,
                        status     : xhr.status,
                        statusText : xhr.statusText,
                        ok         : (xhr.status >= 200 && xhr.status <= 299)
                    };

                    if (xhrResponse.ok) {
                        observer.next(xhrResponse);
                        observer.complete();
                    } else {
                        observer.error(xhrResponse)
                    }
                };

                xhr.addEventListener('load', loadHandler);

                xhr.send(data);

                return () => {
                    xhr.removeEventListener('load', loadHandler);
                    xhr.abort();
                }
            }
        );
    }

    public get(path : string, headers ?: IXhrHeaders, options ?: IXhrOptions) : Observable<IXhrResponse> {
        return this.request("GET", path, null, headers, options);
    }
    public post(path : string, data ?: any, headers ?: IXhrHeaders, options ?: IXhrOptions) : Observable<IXhrResponse> {
        return this.request("POST", path, data, headers, options);
    }
    public request(method : string, path : string, data : any, headers ?: IXhrHeaders, options ?: IXhrOptions) : Observable<IXhrResponse> {
        let xhr : XMLHttpRequest = this._createXhr(method.toUpperCase(), path, true);
        this._mergeHeaders(xhr, headers);
        this._mergeOptions(xhr, options);
        return this._doRequest(xhr, data);
    }
}


// WEBPACK FOOTER //
// C:/prj/liveplanet-app-site/src/app/sas/xhr.sas.ts